<template>
  <v-card width="100vw" height="90vh" elevation="0">
    <v-container fill-height>
      <v-col cols="12" justify="center" align="center">
        <v-progress-circular
          :width="5"
          :size="100"
          color="primary"
          indeterminate
        />
        <div>Cargando propiedades...</div>
      </v-col>
    </v-container>
  </v-card>
</template>
<script>
export default {
  name: "LoadingPropertys"
};
</script>
